import React, {Component} from 'react'
import PropTypes, { object } from 'prop-types'
import { connect } from 'react-redux'

// Actions
import {
    postCompanyLine
    // ESGScopeTypes
} from '../../../../actions/esg'

// Utils
import { translation } from '../../../../utils/helpers'
import { reverseFormatCurrency2 } from '../../../../utils/currency'

// Elements
import Text from '../../../../shared/elements/text'
import Label from '../../../../shared/elements/label'
import TableRow from '../../../../shared/elements/tableRow'

import DecimalInput from '../../../../shared/components/DecimalInput'

import '../../Chain/View/index.scss'

const EntryRestriction = { Hide: 0, CanSee: 1, CanEnterData: 2 }
class Categories extends Component {
  constructor (props) {
    super(props)
    this.cols = ['3fr', [2, 2], [6, 1]]
    this.maxDecimals = 3
  }

  render () {
    let propCategories = this.props.categories
    let disableAllInput = this.props.disableAllInput

    const renderCategory = (category, index) => {
      const applyCategoryChange = (change) => {
        let categories = [...propCategories]
        categories[index] = { ...category, ...change }
        this.props.bubbleUpChange({ Categories: categories })
      }

      const renderLine = (line, index) => {
        const applyLineCahnge = (change) => {
          let lines = [...category.Lines]
          lines[index] = { ...line, ...change }
          applyCategoryChange({ Lines: lines })
        }

        const saveLine = () => {
          let data = { ...line }
          data.Q1Amount = reverseFormatCurrency2(data.Q1Amount)
          data.Q2Amount = reverseFormatCurrency2(data.Q2Amount)
          data.Q3Amount = reverseFormatCurrency2(data.Q3Amount)
          data.Q4Amount = reverseFormatCurrency2(data.Q4Amount)

          this.props.postCompanyLine(data).then((res) => {
            applyLineCahnge(res.data)
            window.toastr.success(translation(893), translation('13424'))
          }, () => {
            window.toastr.error(translation(960), translation('216'))
          })
        }

        const onLineChange = ({ target: { value, name } }) => applyLineCahnge({ [name]: value })
        return (
          <TableRow key={index} cols={this.cols} className='line'>
            <Label>{line.Name}</Label>
            {line.EntryRestriction === EntryRestriction.Hide && <div />}
            {line.EntryRestriction === EntryRestriction.CanSee && <Label>{line.EntryValue}</Label>}
            {line.EntryRestriction === EntryRestriction.CanEnterData && <Text size='s' name='EntryValue' value={line.EntryValue} onChange={onLineChange} onBlur={() => saveLine()} />}
            {line.UnitRestriction === EntryRestriction.Hide && <div />}
            {line.UnitRestriction === EntryRestriction.CanSee && <Label>{line.UnitValue}</Label>}
            {line.UnitRestriction === EntryRestriction.CanEnterData && <Text size='s' name='UnitValue' value={line.UnitValue} onChange={onLineChange} onBlur={() => saveLine()} />}
            <DecimalInput size='s' name='Q1Amount' value={line.Q1Amount} onChange={onLineChange} onBlur={() => saveLine()} decimals={this.maxDecimals} disabled={disableAllInput} />
            <DecimalInput size='s' name='Q2Amount' value={line.Q2Amount} onChange={onLineChange} onBlur={() => saveLine()} decimals={this.maxDecimals} disabled={disableAllInput} />
            <DecimalInput size='s' name='Q3Amount' value={line.Q3Amount} onChange={onLineChange} onBlur={() => saveLine()} decimals={this.maxDecimals} disabled={disableAllInput} />
            <DecimalInput size='s' name='Q4Amount' value={line.Q4Amount} onChange={onLineChange} onBlur={() => saveLine()} decimals={this.maxDecimals} disabled={disableAllInput} />
            <DecimalInput size='s' name='QTotal' value={line.QTotal} disabled />
            {!line.ShowConvertedUnit && <div />}
            {line.ShowConvertedUnit && <DecimalInput size='s' name='QConverted' value={line.TotalConvertedUnit} disabled />}
          </TableRow>
        )
      }

      return (
        <div key={index} className='pg-mb-3'>
          <TableRow header cols={this.cols} className='category-header'>
            <Label size='s'>{category.Name}</Label>
            {!category.ShowEntryColumn && <div />}
            {category.ShowEntryColumn && <Label size='s'>{category.EntryName}</Label>}
            {!category.ShowUnitColumn && <div />}
            {category.ShowUnitColumn && <Label size='s'>{category.UnitName}</Label>}
            <Label size='s'>{`1.\u00A0` + translation(18426)}</Label>
            <Label size='s'>{`2.\u00A0` + translation(18426)}</Label>
            <Label size='s'>{`3.\u00A0` + translation(18426)}</Label>
            <Label size='s'>{`4.\u00A0` + translation(18426)}</Label>
            <Label size='s'>{translation(13353)}</Label>
            {!category.ShowConvertedUnitColumn && <div />}
            {category.ShowConvertedUnitColumn && <Label size='s'>{category.UnitConversionName}</Label>}
          </TableRow>
          {category.Lines.map(renderLine)}
        </div>
      )
    }

    return (
      <div>
        {propCategories.map(renderCategory)}
      </div>
    )
  }
}

Categories.propTypes = {
  bubbleUpChange: PropTypes.func.isRequired,
  categories: PropTypes.arrayOf(object).isRequired,
  disableAllInput: PropTypes.bool
}

export default connect(null, {
  postCompanyLine
})(Categories)



// WEBPACK FOOTER //
// ./src/app/pages/ESG/Company/Components/categories.js